import React from "react";
import { motion } from "framer-motion";

const INSIGHTS = [
    { label: "Auto-cicatrisant", value: "micro-rayures" },
    { label: "Couverture", value: "bords incurvés" },
    { label: "Toucher", value: "souple & glissant" },
];

const HydrogelHero = () => {
    return (
        <div className="relative w-full h-full select-none">
            {/* Soft gold-purple glow halo */}
            <div
                className="absolute inset-0 dp-pulse"
                style={{
                    background:
                        "radial-gradient(45% 35% at 55% 45%, rgba(212,175,55,0.22), transparent 70%), radial-gradient(35% 30% at 75% 65%, rgba(139,92,246,0.18), transparent 70%)",
                    filter: "blur(10px)",
                }}
            />

            <motion.svg
                viewBox="0 0 520 520"
                className="relative z-10 w-full h-full"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden
                initial={{ opacity: 0, y: 16, scale: 0.96 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            >
                <defs>
                    <linearGradient id="phoneBody" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stopColor="#f5f5f7" />
                        <stop offset="50%" stopColor="#ffffff" />
                        <stop offset="100%" stopColor="#e5e5ea" />
                    </linearGradient>
                    <linearGradient id="screenGrad" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#1c1c1e" />
                        <stop offset="100%" stopColor="#0b0b0d" />
                    </linearGradient>
                    <linearGradient id="hydrogelFilm" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stopColor="rgba(212,175,55,0.35)" />
                        <stop offset="55%" stopColor="rgba(139,92,246,0.18)" />
                        <stop offset="100%" stopColor="rgba(212,175,55,0.28)" />
                    </linearGradient>
                    <linearGradient id="filmShine" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stopColor="rgba(255,255,255,0.7)" />
                        <stop offset="50%" stopColor="rgba(255,255,255,0)" />
                        <stop offset="100%" stopColor="rgba(255,255,255,0.4)" />
                    </linearGradient>
                    <filter id="softShadow" x="-20%" y="-20%" width="140%" height="140%">
                        <feGaussianBlur in="SourceAlpha" stdDeviation="8" />
                        <feOffset dy="10" />
                        <feComponentTransfer>
                            <feFuncA type="linear" slope="0.28" />
                        </feComponentTransfer>
                        <feMerge>
                            <feMergeNode />
                            <feMergeNode in="SourceGraphic" />
                        </feMerge>
                    </filter>
                </defs>

                <g filter="url(#softShadow)">
                    {/* Phone body */}
                    <rect
                        x="160"
                        y="70"
                        width="200"
                        height="380"
                        rx="34"
                        fill="url(#phoneBody)"
                    />
                    {/* Screen */}
                    <rect
                        x="174"
                        y="88"
                        width="172"
                        height="320"
                        rx="26"
                        fill="url(#screenGrad)"
                    />
                    {/* Dynamic island */}
                    <rect x="226" y="102" width="68" height="18" rx="9" fill="#1c1c1e" />

                    {/* Hydrogel film layer */}
                    <rect
                        x="176"
                        y="90"
                        width="168"
                        height="316"
                        rx="24"
                        fill="url(#hydrogelFilm)"
                        stroke="rgba(212,175,55,0.5)"
                        strokeWidth="1.2"
                    />
                    {/* Film shine */}
                    <path
                        d="M176 170 L344 130 L344 210 L176 250 Z"
                        fill="url(#filmShine)"
                        opacity="0.35"
                    />
                    {/* Film edge highlight */}
                    <rect
                        x="180"
                        y="94"
                        width="160"
                        height="308"
                        rx="22"
                        fill="none"
                        stroke="rgba(139,92,246,0.35)"
                        strokeWidth="0.8"
                    />

                    {/* Droplet / hydrogel symbol */}
                    <circle cx="260" cy="248" r="24" fill="rgba(139,92,246,0.15)" />
                    <path
                        d="M260 232 C260 232 248 250 248 256 C248 263 253 268 260 268 C267 268 272 263 272 256 C272 250 260 232 260 232 Z"
                        fill="url(#hydrogelFilm)"
                        stroke="rgba(212,175,55,0.6)"
                        strokeWidth="1"
                    />
                </g>

                {/* Dimension / blueprint hints */}
                <g stroke="rgba(212,175,55,0.5)" strokeWidth="0.7" fill="none" opacity="0.7">
                    <line x1="150" y1="90" x2="150" y2="430" strokeDasharray="3 4" />
                    <line x1="370" y1="90" x2="370" y2="430" strokeDasharray="3 4" />
                </g>
                <text
                    x="260"
                    y="475"
                    textAnchor="middle"
                    fontSize="11"
                    fontFamily="JetBrains Mono"
                    fill="#8b5cf6"
                    opacity="0.9"
                >
                    HYDROGEL · DÈS 50 DH
                </text>
            </motion.svg>

            {/* Floating chips */}
            {INSIGHTS.map((chip, i) => {
                const positions = [
                    "top-6 right-0 md:-right-4",
                    "bottom-20 -left-2 md:-left-8",
                    "bottom-4 right-2 md:-right-2",
                ];
                return (
                    <motion.div
                        key={chip.label}
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.5 + i * 0.15, duration: 0.6 }}
                        className={`absolute ${positions[i]} dp-glass rounded-2xl px-4 py-3 text-left border border-[#d4af37]/15 shadow-[0_10px_30px_-10px_rgba(139,92,246,0.18)]`}
                    >
                        <div className="dp-eyebrow !text-[10px]">{chip.label}</div>
                        <div className="font-display text-sm">{chip.value}</div>
                    </motion.div>
                );
            })}
        </div>
    );
};

export default HydrogelHero;
